import { ControlIcons } from 'owa-control-icons';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';

const maxWidth = 900;

export const enum NotificationType {
    Success,
    Error,
}

/**
 * show notification for success/error actions happening in hub
 * @param notificationId unique identifier to identify the notification
 * @param notificationText text to display inside notification
 * @param type indicating type of notification
 */
export function showNotification(
    notificationId: string,
    notificationText: string,
    type: NotificationType,
    primaryActionText: string | undefined,
    primaryAction: () => void | undefined
): void {
    lazyShowNotification.importAndExecute(
        notificationId,
        'PeopleModuleNotificationBarHost',
        notificationText,
        {
            icon:
                type === NotificationType.Success
                    ? ControlIcons.Completed
                    : ControlIcons.ErrorBadge,
            primaryActionText: primaryActionText,
            shouldShowDismissIcon: true,
            maxWidth: maxWidth,
            notificationCallback: reason => {
                if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                    primaryAction();
                }
            },
            allowAutoDismiss: type === NotificationType.Success,
        }
    );
}
